import R from "ramda";

import { extractErrorMessage } from "src/sdk";

const getErrorFromGraphQLError = t => error => {
  const errors = R.path(["extensions", "response", "body", "errors"], error);

  if (errors) {
    return errors.map(error => {
      const errorMessage = extractErrorMessage(error);

      console.debug(
        "Getting error message from GraphQL message",
        error,
        errorMessage,
        Boolean(t)
      );

      if (t && error.messageKey) {
        const message = t(error.messageKey, {
          errorMessage,
        });
        console.debug("Got message", message);
        return message;
      }

      return errorMessage;
    });
  }

  return [];
};

const getErrorKeysFromGraphQLError = error => {
  const errors = R.path(["extensions", "response", "body", "errors"], error);
  if (errors) {
    return errors.map(error => error.messageKey);
  }

  return [];
};

export const getErrors = (error, t) => {
  if (error && error.graphQLErrors) {
    const [authenticationErrors, otherErrors] = R.partition(error =>
      R.contains(error.message, ["403: Forbidden", "401: Unauthorized"])
    )(error.graphQLErrors);

    const maintenanceError = R.find(error =>
      R.contains("503: Service Unavailable", error.message)
    )(otherErrors);

    const errorMessages = otherErrors
      ? R.pipe(R.map(getErrorFromGraphQLError(t)), R.flatten)(otherErrors)
      : undefined;

    const errorMessageKeys = otherErrors
      ? R.pipe(R.map(getErrorKeysFromGraphQLError), R.flatten)(otherErrors)
      : undefined;

    return {
      authenticationErrors,
      errorMessages,
      errorMessageKeys,
      maintenanceError,
    };
  }

  return {};
};

// api.insufficientFunds



// WEBPACK FOOTER //
// ./src/graphql/errors.js